import React from 'react';
import './index.css';
import ReactDOM from 'react-dom';
import SamuraiJSApp from './App';

ReactDOM.render(
    <SamuraiJSApp/>,
    document.getElementById('root')
);